<template>
    <div style="display: flex; justify-content: space-evenly">
        <div id="Wrapper" class="flexContainerColCenter" style="overflow:auto">
            <h2>{{ $t('tournamentregistrationExpress.Header') }}</h2>
            <!--<div id="ObererBereich" class="flexContainerRowSB-center">
                <div id="LinkerBereich">-->
                    <h3>{{ $t('tournamentregistrationExpress.HeaderTournamentSelection') }}</h3>
                    <Grid ref="gridTurniere"
                          :style="{ width: '650px' }"
                          :data-items="gridDataTurniereComputed"
                          :loader="loaderTurniere"
                          :selected-field="selectedFieldTurniere"
                          @rowclick="onRowClickedTurniere"
                          :columns="columnsTurniere">
                        <grid-norecords>{{ $t('tournamentregistrationExpress.NotificationNoData') }}</grid-norecords>
                    </Grid>
                <!--</div>-->
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <!--<div id="RechterBereich">-->
                    <h3>{{ $t('tournamentregistrationExpress.HeaderFormTypes') }}</h3>
                    <combobox :style="{ width: '340px' }"
                              :data-items="comboDataFormenarten"
                              :text-field="'bezeichnung'"
                              :data-item-key="'refFormenarten'"
                              :value-field="'refFormenarten'"
                              :value-primitive="true"
                              @change="handleChangeFormenarten"
                              :value="selectedPrimFormenarten">
                    </combobox>
                <!--</div>-->
            <!--</div>-->
            <div id="UntererBereich" class="flexContainerRowSB-center">
                <div id="LinkerBereich" v-show="visibleKlassen">
                    <h3>{{ $t('tournamentregistrationExpress.HeaderClasses') }}</h3>
                    <Grid ref="gridKlassen"
                          :style="{ width: '650px', height: '500px' }"
                          :data-items="gridDataKlassenComputed"
                          :loader="loaderKlassen"
                          :selected-field="selectedFieldKlassen"
                          @selectionchange="onSelectionChangeKlassen"
                          :columns="columnsKlassen">
                        <grid-norecords>{{ $t('tournamentregistrationExpress.NotificationNoData') }}</grid-norecords>
                    </Grid>
                </div>
            </div>
            <br />
            <div>
                <kbutton title="Anmelden" :theme-color="'primary'" @click="onAnmeldenClick">
                    {{ $t('tournamentregistrationExpress.buttonApply') }}
                </kbutton>
            </div>
        </div>
    </div>
</template>

<script>
    import { Dialog, DialogActionsBar } from '@progress/kendo-vue-dialogs';
    import { ComboBox } from '@progress/kendo-vue-dropdowns';
    import { Grid, GridToolbar, GridNoRecords } from "@progress/kendo-vue-grid";
    import { Button } from "@progress/kendo-vue-buttons";
    import { Input } from '@progress/kendo-vue-inputs';
    import { Fade } from '@progress/kendo-vue-animation';
    import { Notification, NotificationGroup } from '@progress/kendo-vue-notification';
    import { TextBox as KTextBox } from "@progress/kendo-vue-inputs";
    import config from "@/appdata/config.json";
    import axios from 'axios';
    import store from '@/store/store.js';

    export default {
        components: {
            'k-dialog': Dialog,
            'dialog-actions-bar': DialogActionsBar,
            Grid: Grid,
            "grid-norecords": GridNoRecords,
            "grid-toolbar": GridToolbar,
            'combobox': ComboBox,
            kbutton: Button,
            'k-input': Input,
            KTextBox,
            Fade,
            Notification,
            NotificationGroup,
            store
        },
        data: function () {
            return {
                refVereine: 0,
                baseUrlTurniere: '',
                baseUrlKlassen: '',
                baseUrlTeilnehmerZugeordnet: '',
                baseUrlSportlerauswahl: '',
                baseComboUrlFormenarten: '',
                baseComboUrlFormen: '',
                init: { method: "GET", accept: "application/json", headers: {} },
                pageable: false,
                gridDataTurniere: [],
                selectedFieldTurniere: "selectedTurniere",
                selectedPrimTurniere: 0,
                gridDataKlassen: [],
                selectedFieldKlassen: "selectedKlassen",
                selectedPrimKlassen: 0,
                gridDataSportlerauswahl: [],
                selectedFieldSportlerauswahl: "selectedSportlerauswahl",
                selectedPrimSportlerauswahl: 0,
                gridDataTeamauswahl: [],
                selectedFieldTeamauswahl: "selectedTeamauswahl",
                selectedPrimTeamauswahl: 0,
                comboDataFormenarten: [],
                selectedPrimFormenarten: 0,
                comboDataForm1: [],
                selectedPrimForm1: 0,
                comboDataForm2: [],
                selectedPrimForm2: 0,
                deleteurlLoeschen: '',
                deleteurlFormen: '',
                posturlHinzufuegen: '',
                posturlFormen: '',
                patchurlPoomsaeEdit: '',
                visibleDialog: false,
                visibleFormenauswahl: false,
                visibleDialogEdit: false,
                visibleKlassen: false,
                columnsTurniere: [
                    { field: "prim", editable: false, hidden: true, width: 100, title: "Prim" },
                    { field: "name", editable: false, width: 230, title: this.$t('tournamentregistrationExpress.GridColumnHeaderName') },
                    { field: "ort", editable: false, width: 120, title: this.$t('tournamentregistrationExpress.GridColumnHeaderLocation') },
                    { field: "datum", type: "date", format: "{0:dd.MM.yyyy}", editable: false, width: 100, title: this.$t('tournamentregistrationExpress.GridColumnHeaderDate') },
                    { field: "meldeschluss", type: "date", format: "{0:dd.MM.yyyy}", editable: false, width: 120, title: this.$t('tournamentregistrationExpress.GridColumnHeaderClosingDate') },
                ],
                columnsKlassen: [
                    { field: "selectedKlassen", width: 50, title: "Bla" },
                    { field: "prim", editable: false, hidden: true, width: 100, title: "Prim" },
                    { field: "refKlasse", hidden: true, editable: false, width: 120, title: "refKlasse" },
                    { field: "refFormenarten", hidden: true, editable: false, width: 120, title: "refFormenarten" },
                    { field: "name", editable: false, width: 140, title: this.$t('tournamentregistrationExpress.GridColumnHeaderName')  },
                { field: "vorname", editable: false, width: 140, title: this.$t('tournamentregistrationExpress.GridColumnHeaderFirstName') },
                    { field: "klasse", editable: false, width: 320, title: this.$t('tournamentregistrationExpress.GridColumnHeaderClass')  },
                    { field: "refParaklasse", hidden: true, editable: false, width: 350, title: "refParaklasse" }
                ],
                loaderTurniere: false,
                totalTurniere: 0,
                success: false,
                error: false,
                forceComputedUpdatex1: null,
                forceComputedUpdatex2: null,
                nameOrTeam: '',
                maxStartsCheck: 0,
                anzahlStarts: 0
            };
        },
        computed: {
            gridDataTurniereComputed() {
                if (this.forceComputedUpdatex1 === null || this.forceComputedUpdatex1 === 'undefined') {
                    return [];
                } else {
                    return this.gridDataTurniere.map((item) => ({ prim: item.prim, name: item.name, datum: item.datum, ort: item.ort, meldeschluss: item.meldeschluss, selectedTurniere: (item.prim === this.selectedPrimTurniere) }));
                }
            },
            gridDataKlassenComputed() {
                if (this.forceComputedUpdatex2 === null || this.forceComputedUpdatex2 === 'undefined') {
                    return [];
                } else {
                    return this.gridDataKlassen.map((item) => ({ prim: item.prim, refKlasse: item.refKlasse, klasse: item.klasse, refFormenarten: item.refFormenarten, name: item.name, vorname: item.vorname, refParaklasse: item.refParaklasse, selectedKlassen: (item.refKlasse === this.selectedPrimKlassen) }));
                }
            },
        },
        created: function () {
            this.baseUrlTurniere = config[0].ServiceUrl + config[0].ServiceUrlPort + "/AktuelleTurniereManagement";
            this.getDataTurniere();
        },
        methods: {
            onAnmeldenClick() {
                //Wenn das Grid �berhaupt Zeilen hat
                if (this.gridDataKlassenComputed.length > 0) {
                    //Filter auf selectierte Items
                    const selectedItems = this.gridDataKlassenComputed.filter((item) => {
                        if (item.selectedKlassen === true)
                            return item;
                    });
                    //Wenn gefilterte Items gr��er 0, dann geht es weiter
                    if (selectedItems.length > 0) {
                        for (let i = 0; i < selectedItems.length; i++) {
                            console.log("----------> success 1");
                            //Speichern mit Formen
                            const parameters = {
                                "refTurniere": this.selectedPrimTurniere,
                                "refFormenarten": this.selectedPrimFormenarten,
                                "refKlasseneinteilung": selectedItems[i].refKlasse,
                                "refTeilnehmer": selectedItems[i].prim,
                            };
                            this.posturlHinzufuegen = config[0].ServiceUrl + config[0].ServiceUrlPort + "/InsertTeilnehmerByTurnierFormenartKlasse"
                            axios.post(this.posturlHinzufuegen, parameters)
                                .then((response) => {
                                    console.log("----------> success Hinzufuegen", response);
                                    const parameters = {
                                        "refTurniere": this.selectedPrimTurniere,
                                        "refFormenarten": this.selectedPrimFormenarten,
                                        "refKlasseneinteilung": selectedItems[i].refKlasse,
                                        "refTeilnehmer": selectedItems[i].prim,
                                        "refForm1": 1,
                                        "refForm2": 1,
                                    };
                                    this.posturlFormen = config[0].ServiceUrl + config[0].ServiceUrlPort + "/InsertTeilnehmerFormenByTurnierFormenartKlasse"
                                    axios.post(this.posturlFormen, parameters)
                                        .then((response) => {
                                            console.log("----------> success Formen gespeichert", response);
                                            if (i === selectedItems.length - 1) {
                                                //Wenn es das letzte Element ist, dann Grids neu laden
                                                this.gridDataKlassenComputed = [];
                                                this.gridDataKlassen = [];
                                                //Combobox neu laden
                                                this.getDataFormenarten();
                                            }
                                        })
                                        .catch((error) => {
                                            console.log("---------> error", error);
                                        });
                                })
                                .catch((error) => {
                                    console.log("---------> error", error);
                                });
                        }
                    }
                }
            },
            onRowClickedTurniere(event) {
                this.selectedPrimTurniere = event.dataItem.prim;
                this.visibleKlassen = false;
                this.getDataFormenarten();
            },
            onSelectionChangeKlassen(event) {
                event.dataItem[this.selectedFieldKlassen] = !event.dataItem[this.selectedFieldKlassen];
            },
            handleChangeFormenarten(event) {
                this.selectedPrimFormenarten = event.value;
                this.visibleKlassen = true;
                this.baseUrlKlassen = config[0].ServiceUrl + config[0].ServiceUrlPort + "/PassendeKlasseEinzelByVereinManagement?RefVerein=" + store.primVerein + "&RefTurniere=" + this.selectedPrimTurniere + "&RefFormenarten=" + this.selectedPrimFormenarten;
                this.getDataKlassen();
                //Hier wurde das Turnier fest ausgew�hlt - Nachlesen der Infos zu den Starts
                this.getTurniereMaxStarts();
            },
            getDataTurniere: function (initial) {
                this.forceComputedUpdatex1 = null
                console.log("---->", initial);
                const that = this;
                this.loader = true;

                fetch(
                    this.baseUrlTurniere,
                    //+ "?" + toODataString(this.dataState) + "&$count=true",
                    this.init
                )
                    .then((response) => response.json())
                    .then((json) => {
                        const total = json["@odata.count"];
                        const data = json["data"];
                        if (json.length !== 0) {
                            this.forceComputedUpdatex1 = new Date().getTime();
                            that.totalTurniere = total;
                            that.gridDataTurniere = data;
                            this.loaderTurniere = false;
                        } else {
                            this.forceComputedUpdatex1 = null;
                        }
                    })
                    .finally(() => {
                        this.loaderTurniere = false;
                    });
            },
            getTurniereMaxStarts() {
                axios.get(config[0].ServiceUrl + config[0].ServiceUrlPort + '/MaxStartsCheck', {
                    params: {
                        RefTurniere: this.selectedPrimTurniere
                    }
                })
                    .then((response) => {
                        this.maxStartsCheck = response.data[0].maxStartsCheck;
                        console.log("---->maxStartsCheck", this.maxStartsCheck);

                    })
                    .catch(error => {
                        console.log(error)
                        this.errored = true
                    })
            },
            getDataFormenarten: function () {
                this.selectedPrimFormenarten = null;
                this.baseComboUrlFormenarten = config[0].ServiceUrl + config[0].ServiceUrlPort + "/FormenartenByTurniereManagement?RefTurniere=" + this.selectedPrimTurniere;
                this.comboDataFormenarten = [];
                const that = this;
                fetch(this.baseComboUrlFormenarten, this.init)
                    .then((response) => response.json())
                    .then((json) => {
                        const data = json["data"];
                        that.comboDataFormenarten = data;
                    });
            },
            getDataKlassen: function (initial) {
                this.forceComputedUpdatex2 = null
                console.log("---->", initial);
                const that = this;
                this.loader = true;

                fetch(
                    this.baseUrlKlassen,
                    //+ "?" + toODataString(this.dataState) + "&$count=true",
                    this.init
                )
                    .then((response) => response.json())
                    .then((json) => {
                        const total = json["@odata.count"];
                        const data = json["data"];
                        if (json.length !== 0) {
                            this.forceComputedUpdatex2 = new Date().getTime();
                            that.totalKlassen = total;
                            that.gridDataKlassen = data;
                            this.loaderKlassen = false;
                        } else {
                            this.forceComputedUpdatex2 = null;
                        }
                    })
                    .finally(() => {
                        this.loaderKlassen = false;
                    });
            },
            showNotificationSuccess() {
                /*Meldung anzeigen*/
                this.success = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.success = false;
                }, 3000);
            },
            showNotificationError() {
                /*Meldung anzeigen*/
                this.error = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.error = false;
                }, 3000);
            },
        },
    };
</script>

 Add "scoped" attribute to limit CSS to this component only
<style scoped>
    @import '../css/main.css';
</style>
